var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"lg":"6"}},[_c('pill-basic')],1),_c('b-col',{attrs:{"lg":"6"}},[_c('pill-vertical')],1),_c('b-col',{attrs:{"lg":"6"}},[_c('pill-filled')],1),_c('b-col',{attrs:{"lg":"6"}},[_c('pill-justified')],1),_c('b-col',{attrs:{"cols":"12"}},[_c('pill-alignment')],1),_c('b-col',{attrs:{"cols":"12"}},[_c('pill-themes')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }